import { fromJS } from 'immutable'
import {
  TEAM_DEACTIVATE_REQUEST,
  TEAM_DEACTIVATE_SUCCESS,
  TEAM_DEACTIVATE_FAILURE,
  TEAM_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_DEACTIVATE_SUCCESS:
      return state
        .set('teamDeactivate', fromJS(action.payload.deletedTeam))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case TEAM_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('teamDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case TEAM_DEACTIVATE_RESET:
      return state
        .delete('teamDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team/team-deactivate-reducer.js